import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { map } from 'lodash';

import MenuItem from './MenuItem';
import styles from './AdminOptionMenu.module.css';

const AdminOptionMenu = ({ items, style, selectedItem, closeMenu }) => {
  const containerRef = useRef(null);

  const handleClickOutside = (event) => {
    if (containerRef.current && !containerRef.current.contains(event.target)) {
      closeMenu();
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOutside, false);
    return () => {
      document.removeEventListener('click', handleClickOutside, false);
    };
  }, []);

  return (
    <div className={styles.container} ref={containerRef} style={style}>
      <ul>
        {map(items, (item) => (
          <MenuItem
            key={item.id}
            name={item.name}
            icon={item.icon}
            active={selectedItem === item.value}
            onClick={item.onClick}
            closeMenu={closeMenu}
          />
        ))}
      </ul>
    </div>
  );
};

AdminOptionMenu.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      value: PropTypes.string,
      onClick: PropTypes.func,
    })
  ).isRequired,
  style: PropTypes.shape({}),
  selectedItem: PropTypes.string,
  closeMenu: PropTypes.func.isRequired,
};

AdminOptionMenu.defaultProps = {
  style: null,
  selectedItem: null,
};

export default AdminOptionMenu;
